/**
 * Serviço de Máquinas de Cartão
 * Cadastro das maquininhas da clínica e taxas por parcela
 */

import api from './api';

const maquinaCartaoService = {
  listar: async () => {
    return api.get('/maquinas-cartao');
  },

  criar: async (nome) => {
    return api.post('/maquinas-cartao', { nome });
  },

  atualizar: async (id, dados) => {
    return api.put(`/maquinas-cartao/${id}`, dados);
  },

  remover: async (id) => {
    return api.delete(`/maquinas-cartao/${id}`);
  },

  // Grava as taxas de UMA combinação (modalidade + bandeira; bandeira '' = padrão)
  salvarTaxas: async (id, taxas, { modalidade = 'credito', bandeira = '' } = {}) => {
    return api.put(`/maquinas-cartao/${id}/taxas`, { taxas, modalidade, bandeira });
  },
};

export default maquinaCartaoService;
